<template>
<v-list>
    <v-list-item
        v-for="(item, index) in items"
        :key="index"
        v-on:click="onClick(item)"
    >

        <v-list-item-avatar><v-icon>{{item.icon}}</v-icon></v-list-item-avatar>
        <v-list-item-content>
        <v-list-item-title>{{item.title}}</v-list-item-title>
        <v-list-item-subtitle>{{item.sub_title}}</v-list-item-subtitle>
        </v-list-item-content>
        
    </v-list-item>
</v-list>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: function() { return []; }
        },
    },

    methods: {
        onClick(item) {
            item.action();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>